import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';

interface IndicadorPedidoMultiloja {
    QuantidadePedidoDia: number;
    QuantidadePecaDia: number;
    ValorLiquidoDia: number;
    PrecoMedioDia: number;
    QuantidadePedidoMes: number;
    QuantidadePecaMes: number;
    ValorLiquidoMes: number;
    PrecoMedioMes: number;
    QuantidadePedidoAno: number;
    QuantidadePecaAno: number;
    ValorLiquidoAno: number;
    PrecoMedioAno: number;
    Empresa: Empresa;
}

@Component({
    selector: 'indicador-ped-multilojas',
    templateUrl: 'indicador-ped-multilojas.html'
})
export class IndicadorPedidoMultilojasComponent implements OnInit, OnDestroy {
    @Input('analytic') analytic: boolean = false;

    public data: Date = new Date();

    public pedidoMultilojaDilady: IndicadorPedidoMultiloja;
    public pedidoMultilojaLoveSecret: IndicadorPedidoMultiloja;
    public pedidoMultilojaBanhoDeMar: IndicadorPedidoMultiloja;
    public pedidoMultilojaDoctorSecret: IndicadorPedidoMultiloja;

    public pedidoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this._separarLojas();

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterIndicadorPedidoMultiloja().then(indicadores => {
            this.pedidoMultilojaDilady = indicadores.find(a => _.isEqual(a.Empresa.Id, 1));
            this.pedidoMultilojaLoveSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 2));
            this.pedidoMultilojaBanhoDeMar = indicadores.find(a => _.isEqual(a.Empresa.Id, 3));
            this.pedidoMultilojaDoctorSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 5));

            this.pedidoMultilojaGrupo = {
                QuantidadePedidoDia: _.sum(indicadores.map(a => a.QuantidadePedidoDia)),
                QuantidadePecaDia: _.sum(indicadores.map(a => a.QuantidadePecaDia)),
                ValorLiquidoDia: _.sum(indicadores.map(a => a.ValorLiquidoDia)),
                PrecoMedioDia: 0,
                QuantidadePedidoMes: _.sum(indicadores.map(a => a.QuantidadePedidoMes)),
                QuantidadePecaMes: _.sum(indicadores.map(a => a.QuantidadePecaMes)),
                ValorLiquidoMes: _.sum(indicadores.map(a => a.ValorLiquidoMes)),
                PrecoMedioMes: 0,
                QuantidadePedidoAno: _.sum(indicadores.map(a => a.QuantidadePedidoAno)),
                QuantidadePecaAno: _.sum(indicadores.map(a => a.QuantidadePecaAno)),
                ValorLiquidoAno: _.sum(indicadores.map(a => a.ValorLiquidoAno)),
                PrecoMedioAno: 0
            }

            if (!isNaN(this.pedidoMultilojaGrupo.ValorLiquidoDia / this.pedidoMultilojaGrupo.QuantidadePecaDia))
                this.pedidoMultilojaGrupo.PrecoMedioDia = (this.pedidoMultilojaGrupo.ValorLiquidoDia / this.pedidoMultilojaGrupo.QuantidadePecaDia);
            if (!isNaN(this.pedidoMultilojaGrupo.ValorLiquidoMes / this.pedidoMultilojaGrupo.QuantidadePecaMes))
                this.pedidoMultilojaGrupo.PrecoMedioMes = (this.pedidoMultilojaGrupo.ValorLiquidoMes / this.pedidoMultilojaGrupo.QuantidadePecaMes);
            if (!isNaN(this.pedidoMultilojaGrupo.ValorLiquidoAno / this.pedidoMultilojaGrupo.QuantidadePecaAno))
                this.pedidoMultilojaGrupo.PrecoMedioAno = (this.pedidoMultilojaGrupo.ValorLiquidoAno / this.pedidoMultilojaGrupo.QuantidadePecaAno);

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterIndicadorPedidoMultiloja(): Promise<IndicadorPedidoMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('IndicadorPedidoMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/indicador-ped-multilojas/indicador-ped-multilojas.ts